module.exports = __webpack_public_path__ + "static/media/i_coupon.26b43f4d.svg";